var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNomeSiapreps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 858,
    height: 134,
    viewBox: "0 0 858 134",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_121_39)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M294.126 1.72974H367.349C379.565 1.72974 388.417 4.50018 393.93 10.0182C399.443 15.5362 402.211 24.4199 402.211 36.6236V54.0706C402.211 66.2972 399.443 75.1581 393.93 80.6761C388.417 86.1941 379.542 88.9645 367.349 88.9645H336.147V72.4334C336.147 68.0831 339.693 64.5342 344.039 64.5342H360.372C367.349 64.5342 370.826 61.054 370.826 54.0706V36.6236C370.826 29.6403 367.349 26.16 360.372 26.16H325.51V123.881H309.91C301.217 123.881 294.126 116.783 294.126 108.083V1.72974Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M196.357 123.812H162.365L204.707 11.8497C207.086 5.59899 212.781 1.63794 219.461 1.63794H232.546C239.225 1.63794 244.944 5.57609 247.3 11.8497L289.642 123.812H255.65L251.006 110.899L235.634 66.6175L226.003 38.2949L216.35 66.7091L200.315 112.868L196.38 123.812H196.357Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M608.431 123.812H525.279V2.21045H621.584V13.338C621.584 20.5962 615.659 26.5263 608.408 26.5263H556.504V49.9721H607.699V74.2879H556.504V99.4738H621.584V110.601C621.584 117.859 615.659 123.79 608.408 123.79L608.431 123.812Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M751.995 62.1529C748.907 56.7722 747.375 49.537 747.375 40.4472V35.2269C747.375 23.0689 750.12 14.231 755.61 8.73588C761.1 3.24077 769.929 0.493225 782.076 0.493225H842.993V11.6208C842.993 18.8789 837.068 24.8091 829.817 24.8091H789.007C782.076 24.8091 778.599 28.2893 778.599 35.2269V38.7071C778.599 45.6447 782.076 49.1249 789.007 49.1249H820.255C831.601 49.1249 839.928 51.7809 845.235 57.1157C846.699 58.5581 847.934 60.2525 849.009 62.1529C852.097 67.5335 853.63 74.7687 853.63 83.8585V89.0789C853.63 101.237 850.885 110.075 845.395 115.57C839.905 121.065 831.075 123.812 818.928 123.812H747.649V112.685C747.649 105.427 753.574 99.4967 760.825 99.4967H811.997C818.928 99.4967 822.405 96.0164 822.405 89.0789V85.5986C822.405 78.6611 818.928 75.1808 811.997 75.1808H780.749C769.403 75.1808 761.077 72.5249 755.77 67.19C754.306 65.7247 753.07 64.0533 751.995 62.1529Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.62079 63.8701C5.53265 58.4895 4 51.2542 4 42.1644V36.9441C4 24.7862 6.745 15.9482 12.235 10.4531C17.7251 4.958 26.5549 2.21045 38.7016 2.21045H99.6182V13.338C99.6182 20.5962 93.6935 26.5263 86.4421 26.5263H45.6328C38.7016 26.5263 35.2246 30.0065 35.2246 36.9441V40.4243C35.2246 47.3619 38.7016 50.8421 45.6328 50.8421H76.8803C88.2264 50.8421 96.5529 53.4981 101.86 58.8329C103.301 60.2983 104.559 61.9697 105.634 63.8701C108.723 69.2507 110.255 76.4859 110.255 85.5757V90.7961C110.255 102.954 107.51 111.792 102.02 117.287C96.53 122.782 87.7002 125.53 75.5535 125.53H4.27449V114.402C4.27449 107.144 10.1992 101.214 17.4506 101.214H68.5995C75.5307 101.214 79.0077 97.7337 79.0077 90.7961V87.3159C79.0077 80.3783 75.5307 76.8981 68.5995 76.8981H37.352C26.0059 76.8981 17.6794 74.2421 12.3723 68.9073C10.9312 67.4419 9.67303 65.7705 8.5979 63.8701H8.62079Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.483 2.21045H121.258V123.79H152.483V2.21045Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.783 0.470337H476.464C496.159 0.470337 505.996 9.81202 505.996 28.5183V50.3155C505.996 57.7568 503.914 63.7785 499.751 68.3807C497.669 70.6932 495.084 72.502 492.019 73.83C487.215 75.9135 485.408 81.7521 488.565 85.9421L516.976 123.79H489.022C482.343 123.79 476.098 120.47 472.346 114.906L450.523 82.5077C448.167 79.0274 446.932 74.9061 446.932 70.7161V61.466C446.932 57.0699 450.478 53.521 454.87 53.521H470.905C474.84 53.521 476.807 52.2388 476.807 49.6286V34.2652C476.807 31.6779 474.84 30.3729 470.905 30.3729H440.184V123.79H425.681C416.92 123.79 409.806 116.669 409.806 107.9V0.470337H409.783Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M631.649 1.72974H704.872C717.088 1.72974 725.94 4.50018 731.453 10.0182C736.966 15.5362 739.734 24.4199 739.734 36.6236V54.0706C739.734 66.2972 736.966 75.1581 731.453 80.6761C725.94 86.1941 717.065 88.9645 704.872 88.9645H673.671V72.4334C673.671 68.0831 677.216 64.5342 681.563 64.5342H697.895C704.872 64.5342 708.349 61.054 708.349 54.0706V36.6236C708.349 29.6403 704.872 26.16 697.895 26.16H663.034V123.881H647.433C638.74 123.881 631.649 116.783 631.649 108.083V1.72974Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_121_39",
    x: 0,
    y: 0.470337,
    width: 857.63,
    height: 133.059,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_121_39"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_121_39",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNomeSiapreps);
export default __webpack_public_path__ + "static/media/NomeSiapreps.7af2bf91acda46a2b78d001c0d223eaf.svg";
export { ForwardRef as ReactComponent };